module.exports = __webpack_public_path__ + "static/media/lpi02.3b85a9b0.jpg";